var MDB = window.MDB || {};;
MDB.ConfigEditor = MDB.ConfigEditor || {};

(function () {
    $.extend(MDB.ConfigEditor,
        {
            _findEditor: function(selector){
                selector = $(selector);
                if(selector.is('.config-editor')){
                    return selector;
                }
                
                var editor = selector.closest('.config-editor');
                if(!editor.length){
                    editor = selector
                        .closest('.config-editor-container')
                        .find('.config-editor');
                }
                
                return editor;
            },
            _getTemplate: function(selector){
                console.log(selector);
                return MDB.ConfigEditor._findEditor(selector).data('rowTemplate');
            },
            _initInputs: function(selector){
                var editor = MDB.ConfigEditor._findEditor(selector);

                var keys = editor.find('input[data-type="key"]');
                var values = editor.find('input[data-type="value"]');
                
                values.each(function (i, value) {
                    var me = $(value);

                    me.unbind('focus');
                    me.focus(function (e) {
                        setPassword(keys.eq(i), me);
                    });

                    if (keys.eq(i).val().toLowerCase() === "password") {
                        me.prop('type', 'password');
                    }
                });

                function setPassword(keyControl, valueControl) {
                    if (keyControl.val().toLowerCase() === "password") {
                        valueControl.prop('type', 'password');
                    } else {
                        valueControl.prop('type', 'text');
                    }
                }
            },
            initEditor: function () {
                $('.config-editor-container').each(function(){
                    var me = $(this)
                        , editor = me.find('.config-editor')
                        , template = me.find('.row-template')
                        , addSettingsButton = me.find('.add-config-row');

                    //It's a little hacky but we have to make sure the template will never be included in the form.
                    editor.data('rowTemplate', template.clone());
                    template.remove();

                    addSettingsButton.on('click', function(e){
                        e.preventDefault();
                        MDB.ConfigEditor.addRow(editor);
                    });
                    
                    MDB.ConfigEditor._initInputs(editor);
                    
                    editor.parent().show();
                });
            },
            addRow: function (selector, number) {
                number = number || 1;

                var editor = MDB.ConfigEditor._findEditor(selector);

                for(var i = 0 ; i < number ; i++) {
                    var rowsExist = i > 0 ? true : editor.children().length !== 0;

                    var pattern = /\[(\d+)]/;
                    var template = rowsExist ? editor.children().last().prop('outerHTML') : MDB.ConfigEditor._getTemplate(editor).html();
                    var last = parseInt(pattern.exec(template)[1]);
                    last = rowsExist ? last : -1;
                    
                    //replace values in template
                    template = template
                        .replace(new RegExp('{i}', 'g'), last + 1)
                        .replace(new RegExp('{serialize}', 'g'), 'serialize')
                        .replace(new RegExp('\\[\\d+]', 'g'), '[' + (last + 1) + ']')
                        .replace(new RegExp('_\\d+__', 'g'), '_' + (last + 1) + '__');

                    
                    editor.append(template);
                    editor.children().last().find('input').val('');
                }

                //Re-add validation
                var form = editor.closest('form');
                form.removeData(['validator', 'unobtrusiveValidation']);
                $.validator.unobtrusive.parse(form);
                MDB.ConfigEditor._initInputs(editor);
            },
            removeRow: function (selector, skipReIndex) {
                selector = $(selector);

                //Editor needs to be looked up prior to row deletion
                var editor = MDB.ConfigEditor._findEditor(selector);
                
                var row = selector.is('.config-value-row') ? selector : selector.closest('.config-value-row');
                row.remove();
                
                if(skipReIndex !== true){
                    MDB.ConfigEditor.reIndexRows(editor);
                }
            },
            reIndexRows: function(selector){
                var editor = MDB.ConfigEditor._findEditor(selector);
                var allRows = editor.children('.config-value-row');

                var currentRowIndex = 0;
                // var currentRowIndex = selector.is('.config-value-row') ? allRows.index(row) : 0;
                // var reIndexedRows = allRows.filter(':gt(' + (currentRowIndex - 1) + ')');

                var replaceAttributeIndexing = function(selector, newIndex, attributes){
                    //Quick naive replacement
                    attributes.forEach(function(attributeName){
                        var attributeValue = selector.attr(attributeName);
                        if(!attributeValue){
                            return;
                        }

                        selector.attr(attributeName, attributeValue.replace(/\d+/, newIndex))
                    });
                };

                allRows.each(function(rowIndex){
                    var row = $(this)
                        , newRowIndex = currentRowIndex + rowIndex;

                    row.find('[name],[data-valmsg-for]').each(function(){
                        replaceAttributeIndexing($(this), newRowIndex, ['id', 'name', 'data-valmsg-for', 'aria-describedby'])
                    });
                });
            }
        });
})();